import React, { Component } from 'react'
import { Button, TableRow, TableCell, Typography } from '@material-ui/core'
// utils
import { onChangeEditHOF } from '../../utils/common'

import ModalDialog from '../common/ModalDialog'

export default class PaymentDetailItem extends Component {
  state = {
    selectedSource: null,
  }

  centerAlign = {
    textAlign: 'center',
  }

  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChange = (evt) => {
    this.props.onSourceChange(evt.target.value)
  }

  onDelete = () => {
    // this.setState({selectedSource: sourceId});
    this.confirmModal.handleClickOpen()
  }
  onConfirm = () => {
    const { data } = this.props
    this.props.deleteSource(data.id)
    this.confirmModal.handleClose()
  }
  onClose = () => {}

  render() {
    const { data = {}, defaultSource, subscriptionMap, sourceMap } = this.props
    let message = 'Do you want to delete payment source ' + data.longAccountNumber + ' ?'
    let subscriptionsMessageList = []
    if (data.subscriptionsId.length > 0) {
      subscriptionsMessageList.push('The following subscriptions are using this payment source:')
      data.subscriptionsId.forEach((e) => {
        subscriptionsMessageList.push(subscriptionMap.get(e))
      })
      subscriptionsMessageList.push(
        'If you continue they will be assigned to the default payment source ' +
          sourceMap.get(defaultSource) +
          '.',
      )
    }

    return (
      <TableRow>
        <TableCell colSpan={2} className="padding-small" style={this.centerAlign}>
          {defaultSource === data.id ? <strong>{data.type}</strong> : <div>{data.type}</div>}
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.centerAlign}>
          {defaultSource === data.id ? (
            <strong>{data.accountNumber}</strong>
          ) : (
            <div>{data.accountNumber}</div>
          )}
        </TableCell>
        <TableCell className="cell-wrap-word padding-small" style={this.centerAlign}>
          {defaultSource === data.id ? (
            <strong>{data.expirationDate}</strong>
          ) : (
            <div>{data.expirationDate}</div>
          )}
        </TableCell>
        <TableCell className="padding-small">
          {defaultSource !== data.id ? (
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              className="danger-button"
              onClick={this.onDelete}
            >
              Delete
            </Button>
          ) : null}
        </TableCell>
        <ModalDialog
          title={message}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          onClose={this.onClose}
          confirmText="Yes"
          cancelText="No"
        >
          <Typography variant="subheading" gutterBottom>
            {subscriptionsMessageList.length > 0 ? (
              <div>
                {subscriptionsMessageList.map((element, index) => {
                  return (
                    <div>
                      <span>{element}</span>
                    </div>
                  )
                })}
              </div>
            ) : null}
          </Typography>
        </ModalDialog>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Billing/PaymentDetailItem.js